import { PlusIcon, ProductsIcon } from "@xola/icons";
import { Alert, Button } from "@xola/ui-kit";
import { capitalize } from "lodash";
import { singular } from "pluralize";
import React from "react";
import { useHistory } from "react-router-dom";
import { ProductObject, productTitleMap } from "types";

export const NoProductsAlert = ({
    object,
    isListFiltered = false,
}: {
    object: ProductObject;
    isListFiltered?: boolean;
}) => {
    const history = useHistory();
    const productType = productTitleMap[object];
    const productName = singular(productType);
    const isMerchandise = productName.toLowerCase() === "merchandise";

    const handleCreate = () => {
        history.push(`/products/${productType.toLowerCase()}/new`);
    };

    return (
        <div className="max-w-xl">
            <Alert color="primary">
                <div className="flex p-2">
                    <ProductsIcon size="large" />

                    <div className="ml-2" data-testid="no-product-alert">
                        <div className="mb-3 flex space-x-2">
                            <span className="text-md font-bold">
                                {isMerchandise ? "No Merchandise Found" : `No ${capitalize(productName)}s Found`}
                            </span>
                        </div>
                        {!isListFiltered && (
                            <span className="text-base">
                                {isMerchandise
                                    ? "You do not have any merchandise yet. Please create your first Merchandise item to get started."
                                    : `You do not have any ${productName}s yet. Please create your first ${productName} to get started.`}
                            </span>
                        )}
                        <div className="mt-2 flex justify-end">
                            <Button size="small" color="primary" icon={<PlusIcon />} onClick={handleCreate}>
                                Create {capitalize(productName)}
                            </Button>
                        </div>
                    </div>
                </div>
            </Alert>
        </div>
    );
};
